function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { CustomFormBuilder } from './CustomFormBuilder';
export var PillDropDownBuilder = /*#__PURE__*/function () {
  function PillDropDownBuilder() {
    _classCallCheck(this, PillDropDownBuilder);
  }

  _createClass(PillDropDownBuilder, null, [{
    key: "AddPill",
    value: function AddPill(selectElement, selectedIdx, selectedDiv, inputElement) {
      var _this = this;

      var attr = selectElement.options[selectedIdx];

      if (attr.innerText === "") {
        return;
      }

      var pill = CustomFormBuilder.BuildHtml("span", [["value", attr.value], ["class", "mpp-pill"]], attr.innerText);
      pill.appendChild(CustomFormBuilder.BuildHtml("span", [["class", "mpp-pill-remove"]], "❌", function () {
        _this.RemovePill(pill, selectElement, inputElement);
      }));
      selectedDiv.appendChild(pill);
      this.AddAttributeToOutput(attr.value, inputElement);
      this.ShowOptionByValue(attr.value, false, selectElement);
      selectElement.options[0].selected = true;
    }
  }, {
    key: "ShowOptionByValue",
    value: function ShowOptionByValue(value, show, selectElement) {
      for (var ii = 0; ii < selectElement.options.length; ii++) {
        if (selectElement.options[ii].value === value) {
          selectElement.options[ii].style.display = show ? "" : "none";
          break;
        }
      }
    }
  }, {
    key: "RemovePill",
    value: function RemovePill(pill, selectElement, inputElement) {
      var attrValue = pill.getAttribute("value");
      this.ShowOptionByValue(attrValue, true, selectElement);
      this.RemoveAttributeFromOutput(attrValue, inputElement);
      pill.parentNode.removeChild(pill);
    }
  }, {
    key: "RemoveItemFromArray",
    value: function RemoveItemFromArray(arr, itemval) {
      arr.forEach(function (item, ii) {
        if (item === itemval) {
          arr.splice(ii, 1);
        }
      });
      return arr;
    }
  }, {
    key: "RemoveAttributeFromOutput",
    value: function RemoveAttributeFromOutput(attr, inputElement) {
      var selected = inputElement.value.split(/,/g);
      this.RemoveItemFromArray(selected, attr);
      inputElement.value = selected.join(",");
    }
  }, {
    key: "AddAttributeToOutput",
    value: function AddAttributeToOutput(attr, inputElement) {
      var selected = inputElement.value.split(/,/g);

      if (!this.HasItem(selected, attr)) {
        selected.push(attr);
      }

      this.RemoveItemFromArray(selected, "");
      inputElement.value = selected.join(",");
    }
  }, {
    key: "HasItem",
    value: function HasItem(arr, itemVal) {
      return !arr.every(function (val) {
        return val !== itemVal;
      });
    }
  }]);

  return PillDropDownBuilder;
}();